import store from "@/store";
import messages from "../languages/index";
let lang = localStorage.getItem("language");

export default {
  install(Vue) {
    // // Get operator
    const url = window.location.href.split("/");
    if (url.indexOf("auth") != -1) {
      var op = url.pop().split("?")[0];
      // Verifica se já existe um operador e o renova.
      // Se não envia o novo
      var currentOp = localStorage.getItem("operator");
      if (currentOp != null) {
        // remove
        localStorage.removeItem("operator");
        // renova
        if (currentOp != op) {
          localStorage.setItem("operator", op);
          localStorage.setItem("auth", "false");
          window.location.reload();
        } else {
          localStorage.setItem("operator", currentOp);
        }
      } else {
        localStorage.setItem("operator", op);
      }
    }

    // const urlArray = window.location.href.split("/");
    // const lastIndex = urlArray.length - 1;
    // const op = urlArray[lastIndex];
    // Vue.prototype.$localStorage.setItem("operator", op);
    // Vue.prototype.$localStorage.setItem("operator", 'sys');

    // Get data by operator
    const operator = {
      domain: localStorage.operator,
    };
    // const operator = { domain: "sys" }
    const post = Vue.prototype.$formdata(operator);

    Vue.prototype.$axios.post("/main/infotable", post).then(async (resp) => {
      Vue.prototype.$markets = await resp.data.markets;
      Vue.prototype.$outcomes = await resp.data.outcomes;
      Vue.prototype.$sports = await resp.data.sports;
      Vue.prototype.$operator = await resp.data.operator;

      let payment_providers = [];

      if (Array.isArray(Vue.prototype.$operator.payment_methods)) {
        for (let payment_provider of Vue.prototype.$operator.payment_methods) {
          if (
            !payment_providers.find(
              (provider) => provider.id == payment_provider.id_gateway
            )
          ) {
            let payment_provider_text = "";
            let oldName = payment_provider.nome_gateway;

            if (oldName.includes("Pay4Fun")) {
              const split = oldName.split("Pay4Fun");
              payment_provider_text = `Pay4Fun ${split[1]}`;
            } else if (oldName === "BrasilCash") {
              payment_provider_text = "Brasil Cash";
            } else {
              payment_provider_text = oldName;
            }

            payment_providers.push({
              ...payment_provider,
              id: payment_provider.id_gateway,
              text: payment_provider_text,
              value: payment_provider.nome_gateway.toLowerCase(),
            });
          }
        }
      }

      // if (
      //   payment_providers.find((provider) => provider.text === "PaybrokersV4")
      // ) {
      //   //removendo paybrokers antiga
      //   payment_providers = payment_providers.filter(
      //     (provider) => provider.text !== "Paybrokers"
      //   );

      //   //mudando text e value da paybrokersv4 pra paybrokers
      //   payment_providers = payment_providers.map((provider) => {
      //     if (provider.text === "PaybrokersV4") {
      //       return { ...provider, text: "Paybrokers", value: "paybrokers" };
      //     }

      //     return provider;
      //   });
      // }

      payment_providers.push({
        text: "Manual",
        value: "manual",
      });

      Vue.prototype.$operator = {
        ...Vue.prototype.$operator,
        payment_providers,
      };

      store.commit("sports", Vue.prototype.$sports);
      store.commit("markets", Vue.prototype.$markets);
      store.commit("outcomes", Vue.prototype.$outcomes);
      localStorage.setItem("operator-credit", Vue.prototype.$operator.credit);
      localStorage.setItem("operator-retail", Vue.prototype.$operator.retail);
      localStorage.setItem("operator-casino", Vue.prototype.$operator.casino);
      store.commit("setOperator", Vue.prototype.$operator);
      store.commit("setUrl", Vue.prototype.$operator.url);
    });

    Vue.prototype.$infoTable = {
      markets: function(id) {
        const markets = Vue.prototype.$markets;
        return (
          markets.filter((item) => item.id_market == id)[0] ||
          alert(
            `${process.env.VUE_APP_URL_BASE} \n Maket ID ${id}, não encontrado no InfoTable!`
          )
        );
      },
      outcomes: function(id) {
        const outcomes = Vue.prototype.$outcomes;
        return (
          outcomes.filter((item) => item.id_outcome == id)[0] ||
          alert(
            `${process.env.VUE_APP_URL_BASE} \n Outome ID ${id}, não encontrado no InfoTable!`
          )
        );
      },
      results: function(result_event, status_event) {
        if (result_event == "2") {
          return "encerrada";
        }

        if (status_event == "0") {
          return "cancelado";
        }

        if (result_event == "1") {
          return "acertou";
        }

        if (result_event == "0" && result_event != null) {
          return "errou";
        }

        if (result_event == "" || result_event == null) {
          return "pendente";
        }
      },
      paid: function(id) {
        return id == "1" ? "Sim" : "Não";
      },
      conference: function(result_event, status_event) {
        let result = Vue.prototype.$infoTable.results(
          result_event,
          status_event
        );
        const conf = {
          cancelado: `<span class="my-1 v-chip theme--light v-size--small purple darken-3 white--text"><span class="v-chip__content text">${messages[lang].canceled}</span></span>`,
          acertou: `<span class="my-1 v-chip theme--light v-size--small green darken-3 white--text"><span class="v-chip__content">${messages[lang].right}</span></span>`,
          errou: `<span class="my-1 v-chip theme--light v-size--small red darken-3 white--text"><span class="v-chip__content">${messages[lang].missed}</span></span>`,
          pendente: `<span class="my-1 v-chip theme--light v-size--small grey darken-3 white--text"><span class="v-chip__content">${messages[lang].pending}</span></span>`,
          encerrada: `<span class="my-1 v-chip theme--light v-size--small lime darken-2 white--text"><span class="v-chip__content">${messages[lang].finishedBet}</span></span>`,
        };
        return conf[result];
      },
    };
  },
};
